export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_17-EN-8f371efafac8326b0327b0b6bb6b1cf2.webp";